import { IsEnum, IsInt, IsOptional } from 'class-validator';

import { OrderPositionStatus } from '../order-position-status';

export type OrderPositionListNewRequestRaw = {
    areaId: string | number;
    orderPositionStatus: OrderPositionStatus;
    orderId?: string | number;
};

export class OrderPositionListNewRequest {
    @IsInt()
    public areaId: number;

    @IsEnum(OrderPositionStatus)
    public orderPositionStatus: OrderPositionStatus;

    @IsOptional()
    @IsInt()
    public orderId?: number;

    constructor(data?: Partial<OrderPositionListNewRequestRaw>) {
        this.areaId = typeof data?.areaId === 'number' ? data.areaId : parseInt(data?.areaId, 10);
        this.orderPositionStatus = data?.orderPositionStatus;
        this.orderId = data?.orderId ? (typeof data?.orderId === 'number' ? data.orderId : parseInt(data?.orderId, 10)) : undefined;
    }
}
